module.exports = __webpack_public_path__ + "img/pinxpolicy_headerimage.437515f6.jpg";